import React from 'react';
import { calculateLwA, formatLwA } from '../calculations/acoustics';

class LwA extends React.Component {
    //Ermittelt die Anströmgeschwindigkeit
    _getFlaeche(){
        let breite = parseFloat(this.props.Schalldaempferbreite);
        let h = this.props.Schalldaempferhoehe/1000; // in Meter
        let kulissenbreite = this.props.Kulissenbreite;
        let AnzahlKulissen = this.props.AnzahlKulissen //Anzahl Kulissen == Anzahl Spalten
        let dh = 0;
        // console.log("Druckverlust - Kulissenspalt -> s : " + s);
        // console.log("Druckverlust - Kulissenbreite -> dk : " + dk);

        dh = breite*h - (kulissenbreite*h*AnzahlKulissen);
        return dh;
    }

    _getLwA(){
        //Berechnet die Luftgeschwindigkeit im Kulissenspalt
        let lwa = calculateLwA({
            Kulissenspaltgeschwindigkeit: this.props.Kulissenspaltgeschwindigkeit,
            Schalldaempferbreite: this.props.Schalldaempferbreite,
            Schalldaempferhoehe: this.props.Schalldaempferhoehe,
        });

       // this.props.AnstroemgeschwindigkeitChange(vs);
        return lwa;
    }

    render() {
        //   let test;
        // // eslint-disable-next-line no-unused-expressions
        //
        //   console.log("test Kulissensoaltbreite: " + test)
        return (
            <>{formatLwA(this._getLwA())}
            </>


        );
    }
}
export default LwA;
